import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { TextareaModule } from 'primeng/textarea';
import { LeadService } from 'src/app/private/services/lead.service';
import { LeadActivityService } from 'src/app/private/services/micro-services/leadactivity.service';
import { TaskService } from 'src/app/private/services/micro-services/task.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-lead-task',
  imports: [FormsModule, ButtonModule, TextareaModule],
  templateUrl: './lead-task.component.html',
  styleUrl: './lead-task.component.scss'
})
export class LeadTaskComponent {
  @Output() closeDialog = new EventEmitter<any>();
  @Input() isUpdate: boolean = false;
  @Input() title: string = 'Add Task';
  @Input() editLeadData: any;
  @Input() events: any;

  leadTask = '';
  loading = false;
  lead_id: any;

  @Input() currentLeadId: any;

  constructor(
    private api: LeadService,
    private messageService: MessageService,
    private localStorage: LocalStorageService,
    private route: ActivatedRoute,
    private TaskService: TaskService,
    private leadActivityService: LeadActivityService
  ) {
    this.lead_id = this.route.snapshot.paramMap.get('id');
  }


  ngOnChanges() {
    console.log("editLeadDataTask", this.editLeadData);
    if (this.isUpdate && this.editLeadData) {
      this.leadTask = this.editLeadData.desc;
    }

    if (this.currentLeadId) {
      this.lead_id = this.currentLeadId;
    }
  }


  ngOnInit() {
    if (this.currentLeadId) {
      this.lead_id = this.currentLeadId;
    }
  }

  handleSaveTask() {

    const payload :any = {
      "organization_id": this.localStorage.getOrganizationId(),
      "lead_id": this.lead_id,
      "user_id": this.localStorage.getUserId(),
      "tasks_name": this.leadTask
    }

    this.loading = true;

    if (!this.isUpdate) {
      this.api.createLeadTask(payload).subscribe({
        next: data => {
          this.loading = false;
          this.leadTask = '';
          this.TaskService.addTask(data);
          this.leadActivityService.getAllLeadTimeLineActivity(this.lead_id);
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Task added successfully' });
          this.closeDialog.emit()
        },
        error: error => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to add task' });
        }
      }
      )
    }else{
      payload.id = this.editLeadData.id;

      delete payload.lead_id;

      this.api.updateLeadTask(payload).subscribe({
        next: data => {
          this.loading = false;
          this.events = this.events.map((event: any) => {
            if(event.id == this.editLeadData.id) {
              event.desc = this.leadTask;
            }
            return event;
          })
          this.TaskService.setTasks(this.events);
          this.leadTask = '';
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Task updated successfully' });
          this.closeDialog.emit()
        },
        error: error => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update task' });

        }
      })
    }
  }

  handleClosDialog() {
    this.closeDialog.emit()
  }
}
